module.exports = __webpack_public_path__ + "img/stars-1.401fed26.png";